<hb-modal-dialog [heading]="activeDrawingName" [showFooter]="false">
  <div content>
    <div id="navContainer">
      <div *ngIf="containsMultipleDrawings()" class="move-button-container" title="Previous Drawing" (click)="moveLeft()">
        <i class="fa fa-5x fa-chevron-left"></i>
      </div>
      <div id="drawingsContainer">
        <carousel [interval]="0" [(activeSlide)]="activeSlideIndex" (activeSlideChange)="onActiveSlideChanged($event)" [showIndicators]="false">
          <slide *ngFor="let drawing of drawings; let currentIndex = index">
            <hb-drawing-preview
              [mediaItemDetailsId]="drawing.mediaItemDetailsId"
              *ngIf="isLoadableSlide(currentIndex) || isLoadableAdjacentSlide(currentIndex)"
              (previewLoaded)="onPreviewLoaded($event, drawing.mediaItemDetailsId)"
            ></hb-drawing-preview>
          </slide>
        </carousel>
      </div>
      <div *ngIf="containsMultipleDrawings()" class="move-button-container" title="Next Drawing" (click)="moveRight()">
        <i class="fa fa-5x fa-chevron-right"></i>
      </div>
    </div>
  </div>
</hb-modal-dialog>
